<template>
  <v-card elevation="4" class="mx-auto my-5">
    <ResponsiveImage
      v-if="example.image"
      :imageObject="example.image"
      sizes="(max-width: 600px) 100vw, (min-width: 600px) 50vw, (min-width: 960px) 33vw, (min-width: 1904px) 25vw"
    ></ResponsiveImage>
    <p class="credit" v-if="example.image">
      {{ "&copy; " + example.image.caption }}
    </p>

    <v-card-subtitle class="h-text">
      <h2>{{ example.name }}</h2></v-card-subtitle
    >

    <v-card-text>
      {{ example.shortDescr }}
    </v-card-text>

    <v-card-actions>
      <v-btn
        color="error"
        class="font-weight-bold"
        text
        rounded
        @click="setSheet(example)"
      >
        read more
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ResponsiveImage from "@/components/ResponsiveImage.vue";

export default {
  components: { ResponsiveImage },
  data: function() {
    return {
      api_url: process.env.VUE_APP_STRAPI_API_URL
    };
  },
  props: {
    example: Object
  },
  methods: {
    setSheet: function(example) {
      this.$emit("set-sheet", example);
    }
  }
};
</script>

<style scoped lang="css">
.card-h2 {
  font-size: 1.5em;
}

.v-card__text,
.v-card__title {
  word-break: normal; /* maybe !important  */
}

.credit {
  text-align: right;
  margin-right: 10px;
  margin-bottom: 0;
}
</style>
